import React, { Component, useEffect, useState } from 'react'
import { deleteCourseParticipant, loadCourseParticipants, loadCourse, saveCourse, updateCourseParticipantFavorite } from '../utils/Network';
import HasUserTalentDocument from '../components/HasUserTalentDocument';


import { Link } from 'react-router-dom';
import { BadgeClass, getAge, getDefaultName, userAvatar } from '../utils';

export default function CourseDetailsContent({ id, page , urlParams }) {

    const [course, setCourse] = useState(null);
    const [courseParticipants, setcourseParticipants] = useState(null);
    const [count, setCount] = useState(null);
    const [pages, setPages] = useState(null);
    const [show_delete, setShowDelete] = useState(false);
    const [loading, setLoading] = useState(null);
    const [refresh, setRefresh] = useState(13);

    let filter_favorite = urlParams.get('favorite');
    let filter_city = urlParams.get('city');
    let filter_living_city = urlParams.get('living_city');

    let filter_query = "";
    var filtered = false;

    if (filter_favorite) {
        filter_query += "&favorite=" + filter_favorite;
        filtered =true;
    }

    if (filter_city && filter_city.length > 0) {
        filter_query += "&city=" + filter_city;
        filtered = true;
    }

    if (filter_living_city && filter_living_city.length > 0) {
        filter_query += "&livingcity=" + filter_living_city;
        filtered = true;
    }

    
    if (!page) page = 1
    useEffect(() => {
       
        if (id) {
            getData()

            loadCourse(id).then(course => {
                setCourse(course)
            })

            
        }
    }, [])

    
    const updateIsFavorited = (courseParticipant) => {
        updateCourseParticipantFavorite(courseParticipant.id, !courseParticipant.favorite).then(data => {
            var temp = courseParticipants;
            temp.find(x => x.id ===courseParticipant.id).favorite = !courseParticipant.favorite
            setcourseParticipants(temp)
            setRefresh(refresh+1)
        })
    }

    
    const getData=()=>{
        setLoading(true)
        loadCourseParticipants(id,page,50,filter_query).then(data => {
            setLoading(false)
            if (data && data.count) {
                setCount(data.count)
                var page_count = data.count % 50 === 0 ? parseInt(data.count / 50) : parseInt(data.count / 50) + 1;
                var pages_array = range(1, page_count);
                setPages(pages_array);
            }
            if (data && data.results) {
                setcourseParticipants(data.results);
            }
        })
    }

    const handleDelete = (id, e) => {
        setLoading(id);
        deleteCourseParticipant(id).then(() => {
            getData()
        })
    }

    const showDelete = (e) => {
        e.preventDefault();
        setShowDelete(!show_delete)
    }

    function range(start, end) {
        return Array.apply(0, Array(end))
            .map((element, index) => index + start);
    }

    return (
        <>
            <div className="content-wrapper">
                
                <section className="content">

                    <div className="row">
                        <div className="col-md-12">
                            <div className="box box-primary">
                                <div className="box-header with-border">
                                    <h3 className="box-title">
                                        {course && getDefaultName(course.names)} <span style={{ fontSize: 11 }} >({count})</span> <span style={{ fontSize: 11, color: "#ccc" , marginLeft:5 }} >{course && course.startdate} , {course && course.enddate}</span>

                                    </h3>
                                    <a href="#" title="Show Delete Button" className="btn btn-cm margin-r-5 pull-right " onClick={showDelete}><i className="fa fa-trash"></i></a>
                                    <a href={`coursedetails/${course && course.id}/${filter_favorite ? "" : "?favorite=1"}`} title="Favorites" className="btn btn-cm margin-r-5 pull-right "><i className="fa fa-heart"></i></a>

                                </div>
                                <div className="box-body no-padding ">
                                    <table className="table table-striped cms-course-details-table">
                                        <thead>
                                            <tr>
                                                <th style={{ width: 200 }}>Name</th>
                                                <th className="hide-on-small">Rating</th>
                                                <th className="hide-on-small">Gender</th>
                                                <th>Age</th>
                                                <th className="hide-on-small">POB</th>
                                                <th className="hide-on-small">POR</th>
                                                <th style={{width:50}} ></th>
                                                <th style={{width:50}} ></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {courseParticipants && courseParticipants.map((courseParticipant) => (
                                                <tr key={courseParticipant.id} className={loading && "loading"}>
                                                    <td className="talent-name-cell">
                                                        <div className="talent-name-cell__inner">
                                                            <div className="img-container" >
                                                                <a href={`/cms/usertalent/${courseParticipant.usertalent.user.profile && courseParticipant.usertalent.user.profile.id}`} >
                                                                    <img
                                                                        src={userAvatar(courseParticipant.usertalent.user.profile)}
                                                                        className="width-60 img-list img-circle cms-table-user-avatar"
                                                                        alt=""
                                                                    />
                                                                </a>
                                                            </div>
                                                            <div className="talent-name-cell__text" style={{width: "200px"}}>
                                                                <a className="link-color" href={`/cms/usertalent/${courseParticipant.usertalent.user.profile && courseParticipant.usertalent.user.profile.id}`}>
                                                                    {courseParticipant.usertalent.user.profile && (courseParticipant.usertalent.user.profile.first_name + " " + courseParticipant.usertalent.user.profile.last_name)}
                                                                    <span className="talent-name-cell__date">{courseParticipant.created_at.split('T')[0]}</span>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className="hide-on-small">
                                                        <span className={BadgeClass(courseParticipant.usertalent.rate)}>{courseParticipant.usertalent.rate && (courseParticipant.usertalent.rate).toFixed(2)}</span>
                                                    </td>
                                                    <td className="hide-on-small">{courseParticipant.usertalent.user.profile && courseParticipant.usertalent.user.profile.gender === 0 ? "Male" : courseParticipant.usertalent.user.profile && courseParticipant.usertalent.user.profile.gender === 1 ? "Female" : "Other"}</td>
                                                    <td>
                                                        {courseParticipant.usertalent.user.profile && courseParticipant.usertalent.user.profile.birth_date}
                                                        <br />
                                                        <small>{getAge(courseParticipant.usertalent.user.profile && courseParticipant.usertalent.user.profile.birth_date)} Years old</small>
                                                        

                                                    </td>
                                                    <td className="hide-on-small">
                                                    {courseParticipant.usertalent.user.profile.city && getDefaultName(courseParticipant.usertalent.user.profile.city.names)}
                                                    </td>
                                                    <td className="hide-on-small">
                                                        {courseParticipant.usertalent.user.profile.livingcity && (
                                                            <a href={`/cms/coursedetails/${course && course.id}/?livingcity=${courseParticipant.usertalent.user.profile.livingcity.id}`} >
                                                                {getDefaultName(courseParticipant.usertalent.user.profile.livingcity.names)}
                                                            </a>
                                                        )}
                                                        
                                                    </td>
                                                    <td>
                                                        <button title={`${courseParticipant && courseParticipant.favorite ? "Favorited" : "Not favorited"}`} type="button" onClick={(e) => { updateIsFavorited(courseParticipant) }} className="btn btn-cm btn-sm">
                                                            <i className={`fa fa-heart ${courseParticipant && courseParticipant.favorite ? "color-liked" : "color-notliked"}`}></i>
                                                        </button>
                                                    </td>
                                                    <td>
                                                        <HasUserTalentDocument userdocuments={courseParticipant && courseParticipant.usertalent.userdocuments} profile={courseParticipant && courseParticipant.usertalent.user.profile} playTriggerClassName="btn btn-cm btn-sm" />
                                                        {show_delete && (
                                                        <div className="btn-group">
                                                            <button type="button" onClick={(e) => { if (window.confirm('Are you sure you wish to delete this item?')) handleDelete(courseParticipant.id, e) }} className="btn btn-cm btn-sm">
                                                                <i className="fa fa-trash"></i>
                                                            </button>
                                                        </div>
                                                        ) }
                                                        
                                                    </td>
                                                    
                                                </tr>
                                            )
                                            )}

                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <th>Name</th>
                                                <th className="hide-on-small">Rating</th>
                                                <th className="hide-on-small">Gender</th>
                                                <th>Age</th>
                                                <th className="hide-on-small">POB</th>
                                                <th className="hide-on-small">POR</th>
                                                <th ></th>
                                                <th ></th>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>

                                
                            </div>

                            <ul className="pagination cms-pagination m-0 float-right">
                                <li className="page-item"><Link className="page-link" to="#">«</Link></li>
                                {pages && pages.map((page_number) => (
                                    <li className="page-item">
                                        <a className={page_number == page ? "page-link active" : "page-link"}
                                            href={`/cms/coursedetails/${id}/${page_number}`}>{page_number}</a>
                                    </li>
                                ))}
                                <li className="page-item"><Link className="page-link" to="">»</Link></li>
                            </ul>

                        </div>

                    </div>

                </section>

                


            </div></>


    )

}
